import { SharedModule } from './../../shared/shared.module';
import { SalesAdvisorRoutingModule } from './sales-advisor-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SalesAdvisorComponent } from './sales-advisor.component';



@NgModule({
  declarations: [SalesAdvisorComponent],
  imports: [
    CommonModule,
    SalesAdvisorRoutingModule,
    SharedModule,
    TranslateModule
  ],
  exports:[TranslateModule],
})
export class SalesAdvisorModule { }
